import { CSSProperties, ChangeEvent } from "react"
import "../../styles/input.css"
import { Stack } from "@mui/material"
import Text from "./Text"
import { colors } from "../../services/config/colors"
import searchPrimary from "../../assets/icons/search-primary.svg"

const Input = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  type = "text",
  labelledBy,
  helperText,
  error,
  style,
  multiline = false,
  rows = 4,
}: {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  placeholder?: string
  disabled?: boolean
  type?: "text" | "datetime-local" | "search"
  labelledBy?: string
  helperText?: string
  error?: boolean
  style?: CSSProperties
  multiline?: boolean
  rows?: number
}) => {
  return (
    <Stack gap={1} style={{ position: "relative" }}>
      {multiline ? (
        <textarea
          aria-labelledby={labelledBy}
          className={
            disabled
              ? "custom-input-disabled"
              : error
              ? "custom-input-error"
              : "custom-input"
          }
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={onChange}
          rows={rows}
          style={{
            width: "100%",
            padding: 12,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 500,
            fontFamily: "inherit",
            resize: "none",
            ...style,
          }}
        />
      ) : (
        <input
          aria-labelledby={labelledBy}
          className={
            disabled
              ? "custom-input-disabled"
              : error
              ? "custom-input-error"
              : "custom-input"
          }
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={onChange}
          style={{
            width: "100%",
            height: type === "search" ? 35 : 56,
            paddingLeft: type === "search" ? 39 : 12,
            paddingRight: 12,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 500,
            ...style,
          }}
          type={type}
        />
      )}
      {type === "search" && (
        <img
          src={searchPrimary}
          style={{ position: "absolute", top: 10, left: 12 }}
          alt=""
        />
      )}
      {!!helperText && (
        <Text
          fontSize={12}
          fontWeight={500}
          color={error ? colors.error : colors.text}
        >
          {helperText}
        </Text>
      )}
    </Stack>
  )
}

export default Input
